import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { MAINTENANCE_SETTINGS_PATH } from '&/features/settings/maintenance/paths';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/settings_/maintenance')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the module that owns this path (per the registry) gets the
    // standard not-found. Covers client-side navigation only; the page wraps itself in <ModuleGate>
    // for the hard-refresh case.
    requireModule(context.entitlement, MAINTENANCE_SETTINGS_PATH);
    // Permission gate (separate concern): the redirect-vs-notFound inconsistency with the block
    // above is intentional and left as-is — permission and entitlement are different gates.
    if (context.permissions.isReady && !context.permissions.hasPermission('service-operations:list')) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/maintenance/pages/maintenance-settings-page')),
});
